import React from 'react';
import PropTypes from 'prop-types';
import { Card, List } from 'antd';
import EndorsementForm from './EndorsementForm';
import EndorsementDetail from './EndorsementDetail';

const EndorsementSection = ({ data, loading, isResult }) => {
  const currentStepSequence = data?.stepSequence;

  return (
    <Card title="Endorsement" loading={loading}>
      <List grid={{ gutter: 16, column: 1 }}>
        {data?.endorsementSteps.map((step) => {
          return (
            <List.Item key={step.stepSequence}>
              {isResult || step.stepSequence < currentStepSequence ? (
                <EndorsementDetail step={step} />
              ) : (
                <EndorsementForm
                  step={step}
                  endorsementSequence={data?.endorsementSequence}
                  currentStepSequence={currentStepSequence}
                />
              )}
            </List.Item>
          );
        })}
      </List>
    </Card>
  );
};

EndorsementSection.defaultProps = {
  loading: true,
  isResult: false,
};

EndorsementSection.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  isResult: PropTypes.bool.isRequired,
};

export default EndorsementSection;
